import {useEffect, useMemo, useState} from 'react'

/** Probes `src` off-screen; pass the same `srcSet` as the rendered img so the browser fetches one candidate. */
const useIsImageloaded = (src?: string, srcSet?: string) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isErrored, setIsErrored] = useState(false)

  const loadingState = useMemo(
    () => ({
      isLoaded,
      isErrored
    }),
    [isLoaded, isErrored]
  )

  useEffect(() => {
    if (!src) {
      return
    }

    const image = new Image()

    const onLoad = () => {
      setIsLoaded(true)
      setIsErrored(false)
    }

    const onError = () => {
      setIsErrored(true)
    }

    image.addEventListener('load', onLoad)
    image.addEventListener('error', onError)

    if (srcSet) image.srcset = srcSet
    image.src = src

    return () => {
      image.removeEventListener('load', onLoad)
      image.removeEventListener('error', onError)
    }
  }, [src, srcSet])

  return loadingState
}

export default useIsImageloaded
